function initCollectionDescription(section) {
  const text = section.querySelector('[data-collection-description-text]');
  const button = section.querySelector('[data-collection-description-toggle]');

  if (!text || !button) return;

  function hasContentBefore(br) {
    // Returns true if there is non-empty text or a non-<br> element
    // before this <br> within its immediate parent
    let node = br.parentNode.firstChild;
    while (node && node !== br) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') return true;
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() !== 'br') return true;
      node = node.nextSibling;
    }
    return false;
  }

  function truncateAtBr(pEl) {
    if (pEl.querySelector('[data-hidden-inline]')) return; // already processed

    // Find the first <br> that actually has visible content before it
    const targetBr = Array.from(pEl.querySelectorAll('br')).find(hasContentBefore);
    if (!targetBr) return;

    // collect targetBr + everything after it within its parent
    const nodesToHide = [];
    let node = targetBr;
    while (node) {
      nodesToHide.push(node);
      node = node.nextSibling;
    }
    if (!nodesToHide.length) return;

    const wrapper = document.createElement('span');
    wrapper.setAttribute('data-hidden-inline', '');
    targetBr.parentNode.insertBefore(wrapper, targetBr);
    nodesToHide.forEach(n => wrapper.appendChild(n));
  }

  function markPreviewElements() {
    // metafield_tag wraps content in <div class="metafield-rich_text_field">
    // richtext fields output elements directly — handle both cases
    const firstChild = text.children[0];
    const container =
      firstChild && firstChild.classList.contains('metafield-rich_text_field')
        ? firstChild
        : text;

    const children = Array.from(container.children);
    let foundHeading = false;
    let foundFirstP = false;
    const previewSet = new Set();

    for (const el of children) {
      const tag = el.tagName.toLowerCase();
      if (/^h[1-6]$/.test(tag) && !foundHeading) {
        previewSet.add(el);
        foundHeading = true;
      } else if (tag === 'p' && !foundFirstP && el.textContent.trim() !== '') {
        previewSet.add(el);
        foundFirstP = true;
        truncateAtBr(el);
      }
    }

    for (const el of children) {
      if (previewSet.has(el)) {
        el.removeAttribute('data-hidden');
      } else {
        el.setAttribute('data-hidden', '');
      }
    }

    const hasHiddenBlock = children.some(el => el.hasAttribute('data-hidden'));
    const hasHiddenInline = container.querySelector('[data-hidden-inline]') !== null;
    button.hidden = !hasHiddenBlock && !hasHiddenInline;
  }

  button.addEventListener('click', () => {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isExpanded));
    text.classList.toggle('is-expanded', !isExpanded);
    button.querySelector('.collection-description__read-more-text').textContent = isExpanded ? 'Read more' : 'Read less';
  });

  text.classList.remove('is-expanded');
  button.setAttribute('aria-expanded', 'false');
  button.querySelector('.collection-description__read-more-text').textContent = 'Read more';
  markPreviewElements();
}

document.querySelectorAll('[data-collection-description]').forEach(initCollectionDescription);

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('[data-collection-description]');
  if (section) initCollectionDescription(section);
});
